import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=b0306942&scoped=true&"
import script from "./BottomBar.vue?vue&type=script&lang=ts&"
export * from "./BottomBar.vue?vue&type=script&lang=ts&"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=b0306942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0306942",
  null
  
)

export default component.exports